import { render, staticRenderFns } from "./CompanionAd.vue?vue&type=template&id=622a8c79"
import script from "./CompanionAd.vue?vue&type=script&lang=js"
export * from "./CompanionAd.vue?vue&type=script&lang=js"
import style0 from "./CompanionAd.vue?vue&type=style&index=0&id=622a8c79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports